import { graphql, useStaticQuery } from 'gatsby';
import { getEducationPartners, getOutreachPartners, getImageGallery, getPartnerLogoGridLayoutStyle } from '../utils/utils';

function getPawtnerspageData() {
  const data = useStaticQuery(graphql`
    query PawtnersPageQuery {
      allSanityPage(filter: { slug: { current: { eq: "Pawtners" } } }) {
        edges {
          node {
            _rawBody
          }
        }
      }
    }
  `).allSanityPage.edges[0].node._rawBody;

  const pawtnersPageData = {
    imageGallery: getImageGallery(data),
    partnerLogoGrid: {
      partners: [
        {
          partnerCategory: 'Education',
          partnerList: getEducationPartners(data),
        },
        {
          partnerCategory: 'Outreach',
          partnerList: getOutreachPartners(data),
        },
      ],
      // Here BE must add the Partner logo Grid container and then add the list of partners in it.
      className: getPartnerLogoGridLayoutStyle(data),
    },
  };
  return pawtnersPageData;
}

export default getPawtnerspageData;
